// utils/rem.js
(function (designWidth = 1920, designHeight = 1080, baseFontSize = 75) {
    function calculateREM() {
        const viewWidth = document.documentElement.clientWidth;
        const viewHeight = document.documentElement.clientHeight;

        // 同时计算宽高适配比例
        const widthRatio = viewWidth / designWidth;
        const heightRatio = viewHeight / designHeight;

        // 选择更严格的约束比例（防止内容溢出）
        const strictScale = Math.min(widthRatio, heightRatio);

        // 动态设置REM基准值
        document.documentElement.style.fontSize = `${baseFontSize * strictScale}px`;

        // 记录当前比例（用于特殊场景判断）
        window.__SCALE_FACTOR__ = strictScale;
    }

    // 初始化
    calculateREM();
    // 优化resize监听（兼容多屏系统）
    window.addEventListener('resize', () => {
        requestAnimationFrame(calculateREM);
    }, { passive: true });
})();
